import React, { Component } from "react";
import bankTheme from "../theme/bankTheme";
import InfoPage from "../containers/InfoPage";

class ThemeInfoPage extends Component {
  render() {
    return (
      <div>
        <InfoPage
          history={this.props.history}
          secureToken={this.props.secureToken}
          nextPage="/thememain"
          errorString={this.props.errorString}
          reply={this.props.reply}
        />
      </div>
    );
  }
}

export default bankTheme(ThemeInfoPage);
